export const TAGS_UI = {
  clearFiltersLabel: "Clear filters",
  emptyTitle: "No nodes to display.",
  emptyFilteredTitle: "No node matches these filters",
  bulkEditLabel: (count, selectedRows) => {
    if (
      count >= 1 &&
      Array.isArray(selectedRows) &&
      selectedRows.length > 0 &&
      selectedRows.every((r) => r.uncontextualized)
    ) {
      return count === 1
        ? "Contextualize node"
        : `Contextualize (${count})`;
    }
    return `Bulk edit (${count})`;
  },
  exportCsvLabel: "Export CSV",
  exportCsvLoadingLabel: "Exporting…",
  pageTitle: "Data management",
  pageSubtitle: "Nodes and the contextualization backbone.",
  bulkEditTitle: "Bulk edit node context",
  contextualizeTagsTitle: "Contextualize node",
  bulkEditSubtitle: (count) =>
    `${count} node${count === 1 ? "" : "s"} selected in the filtered view`,
  bulkEditNote:
    "Only the fields you set are written. Leaving a field unchanged leaves that field alone on every selected node.",
  bulkParentHint: "Written to every selected node.",
  toast: {
    contextualized: "Node contextualized successfully.",
    updated: "Node updated successfully.",
    bulkUpdated: (count) => `Bulk edit applied to ${count} nodes.`,
    resolveContextNodeId:
      "Could not resolve context node id for this row.",
    resolveContextNodeIds:
      "Could not resolve context node ids for the selection.",
    exportFailed: "Export failed.",
    exportDownloadUnavailable:
      "Export completed but the download link was not available.",
  },
  validation: {
    nodeTypeRequired: "Select a node type.",
    parentRequired: "Select a parent.",
  },
};

export const TAGS_SCOPE = {
  ALL: "all",
  CONTEXTUALIZED: "contextualized",
  UNCONTEXTUALIZED: "uncontextualized",
};

export const TAGS_SCOPE_TABS = [
  { value: TAGS_SCOPE.ALL, label: "All" },
  { value: TAGS_SCOPE.CONTEXTUALIZED, label: "Contextualized" },
  { value: TAGS_SCOPE.UNCONTEXTUALIZED, label: "Uncontextualized" },
];

export const TAGS_EXPORT_SOURCE_OPTIONS = [
  { value: "mqtt-spb", label: "mqtt-spb" },
  { value: "hachwims", label: "hachwims" },
  { value: "wm-mlengine", label: "wm-mlengine" },
  { value: "wm-app", label: "wm-app" },
];

export const TAGS_TABLE_MIN_WIDTH = 1364;

export const TAGS_COLUMN_WIDTHS = {
  sourceSystem: 132,
  nodeName: 176,
  nodeType: 132,
  nodeSubType: 148,
  parentNode: 208,
  sourceTag: 224,
};
